import { AxiosError } from "axios";
import { useCallback } from "react";
import RootStore from "../../store/root.store";
import { useAuth } from "../auth/use-auth";

type ErrorDialogProps = {
  customMessage?: string[],
  callback?: () => void,
  internalErrorCallback?: () => void,
}

const DEFAULT_ERROR_MESSAGE = 'ネットワークエラーが発生しました。';

/**
 * APIのエラーメッセージを表示用の行配列に変換する
 * 改行コードを含む場合は行ごとに分割し、値が無い場合は既定のメッセージを返す
 */
const toDisplayMessages = (message: any): string[] => {
  /* undefined / null はレスポンス自体が無い場合も含むため既定のメッセージにする */
  if (message === undefined || message === null) return [DEFAULT_ERROR_MESSAGE];
  if (typeof message !== 'string') return [message];
  const messages = message.split(/\r?\n/).filter((v) => !!v);
  return messages.length ? messages : [DEFAULT_ERROR_MESSAGE];
};

export const useApiErrorDialog = () => {
  const { dialog } = RootStore;
  const { checkLogin } = useAuth();
  const push = useCallback((err: AxiosError<any, any>, option?: ErrorDialogProps) => {
    if (!(err instanceof AxiosError)) {
      console.error('error in error hooks !!', err);
      const callback = option?.internalErrorCallback ?? (() => dialog.pop());
      dialog.pushMessage({
        title: 'エラー',
        messages: ['エラーが発生しました。'],
        contentsPadding: '1rem 0.5rem',
        headerProps: {
          css: {
            '.modal_header_wrapper': {
              fontSize: '24px'
            }
          }
        },
        buttons: [
          { label: 'OK', callback },
        ]
      });
      return;
    }
    const is401 = err?.response?.status === 401 && err.response?.data?.message === 'Unauthenticated.';
    if (is401) {
      checkLogin(true);
      return;
    }
    const {
      customMessage = toDisplayMessages(err.response?.data?.message),
      callback = () => dialog.pop(),
    } = option ?? {};
    dialog.pushMessage({
      title: `エラー(CODE: ${err.response?.status ?? 500})`,
      messages: customMessage,
      contentsPadding: '1rem 0.5rem',
      headerProps: {
        css: {
          '.modal_header_wrapper': {
            fontSize: '24px'
          }
        }
      },
      buttons: [
        { label: 'OK', callback },
      ]
    });
  }, [dialog, checkLogin]);
  return {
    push,
  }
}